import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CustomFormControl} from '../custom-form-control';
import {BrandsState} from '../../../../state/brands/brands.state';
import {Observable, Subscription} from 'rxjs';
import {Select, Store} from '@ngxs/store';
import {BrandsActions} from '../../../../state/brands/brands.actions';
import {debounceTime} from 'rxjs/operators';
import {DEBOUNCE_TIME} from '../../../../helpers/form.helper';

@Component({
    selector: 'app-autocomplete-model',
    templateUrl: './autocomplete-model.component.html'
})
export class AutocompleteModelComponent extends CustomFormControl implements OnInit, OnDestroy {
    @Select(BrandsState.modelSearchList) suggestions$: Observable<string[]>;
    @Input() brand: string;
    private subscriptions: Subscription = new Subscription();

    constructor(private store: Store) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.control.valueChanges
                .pipe(debounceTime(DEBOUNCE_TIME))
                .subscribe(
                    (codeSearch) => {
                        if (!!codeSearch) {
                            this.store.dispatch(new BrandsActions.ModelSearchList({codeSearch, brand: this.brand}));
                        }
                    }
                )
        );
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

}
